import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgWarning = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 28,
	height: 28,
	viewBox: "0 0 28 28",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsxs("g", {
		id: "Group_352",
		"data-name": "Group 352",
		transform: "translate(-1040 -304)",
		children: [/* @__PURE__ */ _jsx("g", {
			id: "Group_351",
			"data-name": "Group 351",
			transform: "translate(583 76)",
			children: /* @__PURE__ */ _jsx("circle", {
				id: "Ellipse_9",
				"data-name": "Ellipse 9",
				cx: 14,
				cy: 14,
				r: 14,
				transform: "translate(457 228)",
				fill: "#fff"
			})
		}), /* @__PURE__ */ _jsxs("g", {
			id: "Group_2376",
			"data-name": "Group 2376",
			transform: "translate(1046.109 310.419)",
			children: [
				/* @__PURE__ */ _jsx("g", {
					id: "Group_2364",
					"data-name": "Group 2364",
					transform: "translate(0 0)",
					children: /* @__PURE__ */ _jsx("path", {
						id: "Path_2237",
						"data-name": "Path 2237",
						d: "M208.447,165.254h-12.86a2.012,2.012,0,0,1-1.743-3.018l6.431-11.138h0a2.012,2.012,0,0,1,3.485,0l6.43,11.138a2.012,2.012,0,0,1-1.743,3.018Zm-6.874-13.406-6.431,11.138a.513.513,0,0,0,.444.769h12.86a.513.513,0,0,0,.444-.769l-6.43-11.138a.513.513,0,0,0-.889,0Z",
						transform: "translate(-193.571 -150.092)",
						fill: "#d90b0b"
					})
				}),
				/* @__PURE__ */ _jsx("g", {
					id: "Group_2365",
					"data-name": "Group 2365",
					transform: "translate(7.696 3.431)",
					children: /* @__PURE__ */ _jsx("path", {
						id: "Path_2238",
						"data-name": "Path 2238",
						d: "M214.856,166.1a.75.75,0,0,1-.75-.75V160a.75.75,0,1,1,1.5,0v5.355A.749.749,0,0,1,214.856,166.1Z",
						transform: "translate(-214.106 -159.248)",
						fill: "#d90b0b"
					})
				}),
				/* @__PURE__ */ _jsx("g", {
					id: "Group_2366",
					"data-name": "Group 2366",
					transform: "translate(7.407 10.925)",
					children: /* @__PURE__ */ _jsx("circle", {
						id: "Ellipse_155",
						"data-name": "Ellipse 155",
						cx: 1.039,
						cy: 1.039,
						r: 1.039,
						fill: "#d90b0b"
					})
				})
			]
		})]
	})]
});
const ForwardRef = forwardRef(SvgWarning);
export { ForwardRef as ReactComponent };
